// extracted by mini-css-extract-plugin
module.exports = {"StripeLoaderPayment":"StripeLoaderPayment-module__StripeLoaderPayment___1QCFx","visible":"StripeLoaderPayment-module__visible___3QICz"};